module.exports = __webpack_public_path__ + "img/dotted-map.b039c8f0.png";